import { authAPI } from "services/apis.service";
import { UserInfo } from "../models";

export class UserInfoService {
  #axios;

  constructor(axiosInstance) {
    this.#axios = axiosInstance;
  }

  async getUserInfo() {
    try {
      const response = await this.#axios.get(authAPI.getUserDetails, {
        cache: false,
      });
      return {
        userInfo: new UserInfo(response.data),
        rawData: response.data,
      };
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async updateGradeLicenseKey(groupLicenseKey, userId) {
    try {
      await this.#axios.post(
        authAPI.updateGroupLicenseKey,
        {
          userId,
          groupLicenseKey,
        },
        { cache: false }
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async checkUniqueUsername(username, user) {
    try {
      await this.#axios.post(
        authAPI.uniqueUsername,
        {
          userName: username,
          userId: user.userId,
        },
        { cache: false }
      );
      return true;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async updateProfile(formData) {
    try {
      const { data } = await this.#axios.post(authAPI.updateProfile, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        cache: false,
      });
      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async updateGradeLevel(gradeLevel, userId) {
    try {
      await this.#axios.post(
        authAPI.updateGradeLevel,
        {
          userId,
          gradeLevel,
        },
        { cache: false }
      );
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
}
